import GLOBALS from '../globals'

import ACTIONS from '../actions/types'

const logoutUser = () => {
  if(GLOBALS.history) {

    GLOBALS.removeCookie('auth_token')
    GLOBALS.reduxStore.dispatch({type: ACTIONS.LOGOUT})
    GLOBALS.history.push('/ui/auth')
  }
};

export default logoutUser;
